import styled, { css } from 'styled-components'

interface ContainerProps {
  defaultColor?: boolean
}

export const Container = styled(({ defaultColor, ...rest }) => (
  <div {...rest} />
))<ContainerProps>`
  ${({ theme, defaultColor }) => css`
    svg path {
      fill: ${theme.primaryColor && !defaultColor
        ? theme.primaryColor
        : '#2A5EF6'};
    }
  `}
`
